"use strict";
var SampleModulePopCtrl = (function () {
    function SampleModulePopCtrl($scope, $element) {
        return;
    }
    return SampleModulePopCtrl;
}());
exports.SampleModulePopCtrl = SampleModulePopCtrl;
//# sourceMappingURL=SampleModulePopCtrl.js.map